import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const addNotificationSuccess = (msg) => {
    notification.success({
        message: msg,
    });
};

const state = () => ({
    order: {
        type: 'SUSTAINABILITYCONSULTATION',
        relation: {
            id: null,
            createTimestamp: null,
            modifiedTimestamp: null,
            deletedTimestamp: null,
            isAnonymized: null,
            organizationID: null,
            externalReference: null,
            type: 'CONSUMER',
            isParent: null,
            parentID: null,
            firstName: null,
            middleName: null,
            lastName: null,
            gender: 'MALE',
            birthDate: null,
            phoneNumber: null,
            mobileNumber: null,
            email: null,
            street: null,
            houseNumber: null,
            houseNumberAddition: null,
            postalCode: null,
            city: null,
            country: null,
            companyName: null,
            companyCocNumber: null,
            bankAccountType: null,
            bankAccountNumber: null,
            debtorName: null,
            saveToRevision: false,
        },
        relationID: null,
        signatureType: 'ESIGNATURE',
        signatureData: null,
        productID: null,
        key: 0,
        extraData: {amount: 199},
        flowQuestions: [],
    },
    loadingCreateOrder: false,
    errorCreateOrder: false,
    loadingPreFillRelationOnOrder: false,
    errorPreFillRelationOnOrder: false,
    loadingFetchSustainabilityConsultationFlowQuestions: false,
    errorFetchSustainabilityConsultationFlowQuestions: false,
});

const actions = {
    async resetSustainabilityConsultationOrder({commit}) {
        await commit('resetSustainabilityConsultationOrder');
    },

    async preFillRelationOnSustainabilityConsultationOrder({commit}, data) {
        try {
            await commit('preFillRelationOnSustainabilityConsultationOrderBegin');
            await commit('preFillRelationData', data.value);
            await commit('preFillRelationOnSustainabilityConsultationOrderSuccess');
            await data.stepRoute();
        } catch (err) {
            await commit('preFillRelationOnSustainabilityConsultationOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async addRelationToSustainabilityConsultationOrder({commit}, data) {
        try {
            await commit('addRelationToSustainabilityConsultationOrder', data.value);
            if (data.stepRoute) {
                data.stepRoute();
            }
        } catch (err) {
            addNotificationError(err?.response?.data?.message);
        }
    },

    async createSustainabilityConsultationOrder({commit, state}, data) {
        try {
            await commit('createSustainabilityConsultationOrderBegin');
            const orderToSubmit = data.orderData || state.order;
            const response = await DataService.post('/orders', orderToSubmit);
            await commit('createSustainabilityConsultationOrderSuccess', response.data);
            await data.successRoute();
            addNotificationSuccess('Duurzaamheidsadvies aanvraag is succesvol aangemaakt.');
        } catch (err) {
            await commit('createSustainabilityConsultationOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async fetchSustainabilityConsultationFlowQuestions({commit}, data) {
        console.log('fetchSustainabilityConsultationFlowQuestions called with data:', data);
        try {
            await commit('fetchSustainabilityConsultationFlowQuestionsBegin');
            const response = await DataService.get('offerflow/shop/flowquestions', data);
            await commit('fetchSustainabilityConsultationFlowQuestionsSuccess', response.data);
        } catch (err) {
            console.error('Error fetching flow questions:', err);
            await commit('fetchSustainabilityConsultationFlowQuestionsErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
};

const getters = {
    order: (state) => state.order,
    loadingCreateOrder: (state) => state.loadingCreateOrder,
    errorCreateOrder: (state) => state.errorCreateOrder,
    loadingPreFillRelationOnOrder: (state) => state.loadingPreFillRelationOnOrder,
    errorPreFillRelationOnOrder: (state) => state.errorPreFillRelationOnOrder,
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
};
